<script setup lang="ts">
    import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-vue-next';
</script>

<template>
    <Button
        variant="ghost"
        size="sm"
    >
        <span><slot /></span>
        <Plus class="text-accent" />
    </Button>
</template>
